import MessageFormat from '@messageformat/core';

let messageformatInstance = null;
/**
 * Get or create MessageFormat install 
 * @reutrns {MessageFormat}
 */
export const getMessageFormat = () =>{
    if(!messageformatInstance){
        try{
            // Initinalize with English locale
            messageformatInstance = new MessageFormat('en');
        }catch (error){
            console.error('MessageFormat initialization failed:',error);
            return {
                compile:(message)=>{
                    if(typeof message === 'string'){
                        return (data) => message;
                    }
                    return ()=>''
                }
            }
        }
    }
    return messageformatInstance
};

/**
 * compile a message with MessageFormat
 * @param {string} message - then emssage template to compoile 
 * @return {Function} Compiled message function 
 */

export const compileMessage = (message) =>{
    const mf = getMessageFormat();
    try {
        return mf.compile(message);
    }catch(error){
        console.error('message compilation failed:' , error);
        return ()=> message;
    }
};